import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#6DC66D",
  d: "M3.533 16.467c-.333.334-.878.336-1.182-.026a10 10 0 0 1 0-12.882c.304-.362.849-.36 1.182-.025.334.333.33.872.033 1.239a8.29 8.29 0 0 0 0 10.454c.297.367.301.906-.033 1.24M16.467 16.467c.334.334.878.336 1.182-.026a10 10 0 0 0 0-12.882c-.304-.362-.849-.36-1.182-.025-.334.333-.33.872-.033 1.239a8.29 8.29 0 0 1 0 10.454c-.297.367-.301.906.033 1.24"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#6DC66D",
  d: "M5.618 14.384c-.384.384-1.014.388-1.342-.045a7.18 7.18 0 0 1 0-8.676c.328-.433.958-.43 1.342-.045.384.384.375 1.003.07 1.453a5.215 5.215 0 0 0 0 5.86c.305.45.314 1.069-.07 1.453M14.384 14.384c.384.384 1.014.388 1.342-.045a7.18 7.18 0 0 0 0-8.676c-.328-.433-.958-.43-1.342-.045-.384.384-.375 1.003-.07 1.453a5.215 5.215 0 0 1 0 5.86c-.305.45-.314 1.069.07 1.453M9.104 7.456l-.462.694zm2.746 1.83.462-.693zm0 1.429-.463-.693zm-2.746 1.83-.462-.693zM8.642 8.15l2.745 1.83.925-1.387-2.745-1.83zm2.745 1.872-2.745 1.83.925 1.386 2.745-1.83zM8.603 11.83V8.17H6.936v3.66zm.04.02-.011.006H8.63q-.002.001-.015-.004l-.012-.01-.001-.012H6.936c0 1.351 1.506 2.157 2.63 1.408zm2.744-1.871.007.005.002.003.002.013-.002.013-.002.002-.007.006.925 1.386a1.692 1.692 0 0 0 0-2.815zm-1.82-3.217c-1.125-.75-2.63.056-2.63 1.408h1.666l.001-.012v-.001q.002-.003.012-.01l.015-.004q.002 0 .011.006z"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }